module.exports = __webpack_public_path__ + "case_examples.2f1658e5.pdf";